import React from 'react';
import { Box, Typography } from '@mui/material';

// Pro-looking stacked cell component
const StackedCell = ({ topText, bottomText }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}>
    <Typography variant="body2" sx={{ fontWeight: 600, color: '#1565c0' }}>{topText || 'N/A'}</Typography>
    <Typography variant="caption" sx={{ fontWeight: 500, color: '#78909c' }}>{bottomText || 'N/A'}</Typography>
  </Box>
);

export default StackedCell;